import React from 'react'

import DeviceDetailsButton from '../components/DeviceDetailsButton'
import TableActionsContainer from '../components/TableActionsContainer'

import DeleteDeviceButton from './DeleteDeviceButton'
import FavoriteDeviceButton from './FavoriteDeviceButton'

interface DeviceActionsProps {
  deviceId: string
  reloadDevices: () => void
  favorite?: boolean
}

const DeviceActions: React.FC<DeviceActionsProps> = ({ deviceId, favorite, reloadDevices }) => {
  return (
    <TableActionsContainer>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, auto)', gap: 8 }}>
        <DeviceDetailsButton deviceId={deviceId} />
        <DeleteDeviceButton deviceId={deviceId} onDeviceDeleted={reloadDevices} />
        <FavoriteDeviceButton deviceId={deviceId} favorite={favorite} onDeviceChanged={reloadDevices} />
      </div>
    </TableActionsContainer>
  )
}

export default DeviceActions
